export default __webpack_public_path__ + "static/media/london_m.2009d253.jpg";